/**
 * 线上环境
 */
export const FW_NLINEHOST = 'https://www.emof.cn/index.php/' //服务网正式
export const SZST_URL = 'https://szst.emof.cn/index.php/'
export const ONLINEHOST = 'https://prj.emof.cn/index.php/' //线上正式
// export const ONLINEHOST = 'http://test.1617z.com/index.php/' //线上测试
/**
 * 测试环境
 */
export const QAHOST = 'https://prj.emof.cn/index.php/'
// export const QAHOST = 'http://test.1617z.com/index.php/'
// export const QAHOST = 'http://192.168.2.143:8091'
// export const QAHOST = 'http://192.168.2.122:8089'
// export const QAHOST = 'http://192.168.2.160:7070/'


export const baseURL = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST

export const DOMAIN=  `https://prj.emof.cn`

export const DOMAIN_HTTP=  `http://prj.emof.cn/vw`

//文件地址
export const FILE_PATH = 'http://zcdownload.emof.cn'
//文件上传地址
export const FILE_UPLOAD_HOST = 'https://upload-z1.qiniup.com/'


//版权信息
export const COPYRIGHT_ORG = '益魔方'
export const COPYRIGHT_COMPANY = '北京易魔方科技集团有限公司'
export const COPYRIGHT_ICP = '京ICP备15038897号-3'
export const COPYRIGHT_GA_CODE = '11010802038214'
export const COPYRIGHT_GA_NAME = '京公网安备'


/*
* 百度编辑器配置
* */
export const bdEditConfig = () => {
    return {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 320,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: requestUrl + '/editor/controller.php',
        serverUrl: baseURL + '/editor/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/vw/UEditor/'
    }
}


/*
* CKEditor编辑器配置
* */
export const ckEditConfig = () => {
    return {

    }
}

/*
* 缓存字段
* */
export const localAnStore = [
    {
        key: 'token',
        type: 'localStorage'
    },
    {
        key: 'user',
        type: 'localStorage'
    },
    {
        key: 'cookie_user',
        type: 'cookie',
        day: 365,
        path: '/',
    },
]